<template>
  <div class="card-box">
    <div class="card-box_title">
      <span>竞技比赛</span>
      <a class="text-click" @click="goList('rule', '政策法规')">更多 +</a>
    </div>
    <ul class="card-box_list">
      <li v-for="item in list" :key="item.id">
        <div
          class="text-click"
          @click="goDetail(item.id, 'rule', item.type, item.linkUrl)"
        >
          {{ item.title }}
        </div>
        <div class="time">
          {{ moment(item.releaseTime).format('YYYY-MM-DD') }}
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import moment from 'moment';
import { goDetail, goList } from '@/utils';
export default {
  name: 'homeCard',
  props: {
    title: String,
    type: String,
    list: Array,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_URL,
    };
  },
  methods: {
    moment,
    goDetail,
    goList,
  },
};
</script>

<style lang="scss" scoped>
.card-box {
  width: 100%;
  &_title {
    height: 30px;
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
    border-bottom: 4px solid #ebebeb;
    span {
      text-align: center;
      font-weight: normal;
      font-size: 18px;
      height: 30px;
      border-bottom: 4px solid #d9251e;
    }
    a {
      font-size: 14px;
      color: #000;
      line-height: 30px;
    }
  }
  &_highlight {
    text-align: center;
    font-size: 36px;
    color: #f90101;
    margin: 15px 0;
    font-weight: 600;
    padding: 0 20px;
  }
  &_list {
    li {
      font-size: 14px;
      display: flex;
      justify-content: space-between;
      margin-top: 14px;
      .time {
        flex-shrink: 0;
        width: 90px;
        text-align: right;
      }
    }
  }
}
</style>
